function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export function isError(error) {
  return _typeof(error) === "object" && typeof error.message !== "undefined";
}
export function getStacktrace(error) {
  if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") {
    var _a = error.stacktrace,
      stacktrace = _a === void 0 ? "" : _a;
    return stacktrace.split("\n").filter(function (line) {
      return line !== "";
    });
  } else if (error.stack) {
    var _b = error.stack,
      stack = _b === void 0 ? "" : _b;
    return stack.split("\n").filter(function (line) {
      return line !== "";
    });
  } else {
    return ["No stacktrace available"];
  }
}